import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges } from "@angular/core";
import { IStatisticsListItemConfig } from "./interfaces";
import { StatisticsItemMapper } from "./stats-item.mapper";
import { IRoundBet } from "../../core/round/interfaces";

@Component({
    selector: "statistics-list-item",
    templateUrl: "./statistics-list-item.component.html",
    styleUrls: ["./statistics-list-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatisticsListItemComponent implements OnChanges {
    @Input() statisticsListItemConfig: IRoundBet | undefined = undefined;
    public statisticsListItem: IStatisticsListItemConfig | undefined = undefined;
    public objectKeys = Object.keys;
    constructor(public element: ElementRef) {
    }

    ngOnChanges(): void {
        if (this.statisticsListItemConfig) {
            this.statisticsListItem = StatisticsItemMapper.convert(this.statisticsListItemConfig);
        }
    }

    extractDataFromObject(key: string, object: IStatisticsListItemConfig): any {
        return object[key]?.data ?? undefined;
    }

    extractStyleFromObject(key: string, object: IStatisticsListItemConfig): { [key: string]: any } {
        return object[key]?.style ?? {};
    }
}
